import styled, { css } from 'styled-components';

export const Content = styled.section`
  ${({ theme }) => css`
    font-family: ${theme.v2.font.family.primary};
    padding: 14px;
  `}
`;

export const Info = styled.div`
  ${({ theme }) => css`
    align-items: center;
    display: flex;
    gap: 16px;
    margin-top: 24px;

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      align-items: center;
      flex-direction: column;
    }
  `}
`;

export const InfoText = styled.p`
  ${({ theme }) => css`
    color:  ${theme.v2.colors.neutral.lowPure};
    font-size: 16px;
    margin: 0;

    strong {
      font-weight: ${theme.v2.font.weights.medium};
    }

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      text-align: center;
    }
  `}
`;

export const ButtonAdapter = styled.div``;

export const Actions = styled.div`
  ${({ theme }) => css`
    display: flex;
    gap: 30px;
    justify-content: center;
    margin-top: 40px;

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      align-items: center;
      flex-direction: column;
    }
  `}
`;
